export default __webpack_public_path__ + "static/media/About Page Photo.5adacdbb.svg";